import Model from "./Model";
import ContentModel from "./ContentModel";

export default class SolutionModel extends Model {
  id: number;
  questionId: number;
  contentIds: number[];

  static __typename: string = "Solution";

  constructor(solution: any, getters: any) {
    super(getters);
    this.id = solution.id;
    this.questionId = solution.questionByQuestionId || solution.questionId;
  }

  contents(): ContentModel[] {
    return this.getters
      .contentsBySolutionId(this.id)
      .concat()
      .sort((A:ContentModel, B:ContentModel) => A.position - B.position);
  }

  legacyContent() {
    return this.contents().map((contentComponent: ContentModel) => {
      var content, url, size, origin, description, kalturaId;
      let behavior = contentComponent.behavior();
      switch (behavior) {
        case "text":
          content = contentComponent.text().body;
          break;
        case "video":
          const video = contentComponent.video();
          const providerType = video.providerType;
          const isKalturaProvider = (provider) => provider === 'KALTURA';
          content = video.providerId;
          behavior = isKalturaProvider(providerType) ? 'kalturaVideo' : 'video';
          kalturaId = isKalturaProvider(providerType) ? content : null;
          break;
        case "image":
          let image = contentComponent.image();
          content = "";
          url = image.url;
          size = image.resizeFactor;
          origin = image.source ? image.source.origin : null;
          description = image.description;
          break;
      }
      return {
        behavior,
        content,
        url,
        size,
        origin,
        description,
        kalturaId
      };
    });
  }

  raw() {
    return {
      id: this.id,
      questionId: this.questionId,
      content: this.legacyContent(),
      __typename: SolutionModel.__typename
    };
  }
}